/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceRef,
  ItemInstanceRefOptional,
  ItemInstanceRefMetaI,
  ItemInstanceRefTrackedI,
} from "./item-instance-ref";
import {
  ItemInstanceRefTracked,
  ItemInstanceRefMeta,
} from "./item-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemCalculated,
  LineItemCalculatedOptional,
  LineItemCalculatedMetaI,
  LineItemCalculatedTrackedI,
} from "./line-item-calculated";
import {
  LineItemCalculatedTracked,
  LineItemCalculatedMeta,
} from "./line-item-calculated";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemDTORef,
  LineItemDTORefOptional,
  LineItemDTORefMetaI,
  LineItemDTORefTrackedI,
} from "./line-item-dtoref";
import { LineItemDTORefTracked, LineItemDTORefMeta } from "./line-item-dtoref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemDiscountDTO,
  LineItemDiscountDTOOptional,
  LineItemDiscountDTOMetaI,
  LineItemDiscountDTOTrackedI,
} from "./line-item-discount-dto";
import {
  LineItemDiscountDTOTracked,
  LineItemDiscountDTOMeta,
} from "./line-item-discount-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemFull,
  LineItemFullOptional,
  LineItemFullMetaI,
  LineItemFullTrackedI,
} from "./line-item-full";
import { LineItemFullTracked, LineItemFullMeta } from "./line-item-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRefundDTO,
  LineItemRefundDTOOptional,
  LineItemRefundDTOMetaI,
  LineItemRefundDTOTrackedI,
} from "./line-item-refund-dto";
import {
  LineItemRefundDTOTracked,
  LineItemRefundDTOMeta,
} from "./line-item-refund-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemTaxDTO,
  LineItemTaxDTOOptional,
  LineItemTaxDTOMetaI,
  LineItemTaxDTOTrackedI,
} from "./line-item-tax-dto";
import { LineItemTaxDTOTracked, LineItemTaxDTOMeta } from "./line-item-tax-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameInfoAndRef,
  PersonNameInfoAndRefOptional,
  PersonNameInfoAndRefMetaI,
  PersonNameInfoAndRefTrackedI,
} from "./person-name-info-and-ref";
import {
  PersonNameInfoAndRefTracked,
  PersonNameInfoAndRefMeta,
} from "./person-name-info-and-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonSubscriptionRef,
  PersonSubscriptionRefOptional,
  PersonSubscriptionRefMetaI,
  PersonSubscriptionRefTrackedI,
} from "./person-subscription-ref";
import {
  PersonSubscriptionRefTracked,
  PersonSubscriptionRefMeta,
} from "./person-subscription-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseCardDTO,
  PurchaseCardDTOOptional,
  PurchaseCardDTOMetaI,
  PurchaseCardDTOTrackedI,
} from "./purchase-card-dto";
import {
  PurchaseCardDTOTracked,
  PurchaseCardDTOMeta,
} from "./purchase-card-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseClassSignupDTO,
  PurchaseClassSignupDTOOptional,
  PurchaseClassSignupDTOMetaI,
  PurchaseClassSignupDTOTrackedI,
} from "./purchase-class-signup-dto";
import {
  PurchaseClassSignupDTOTracked,
  PurchaseClassSignupDTOMeta,
} from "./purchase-class-signup-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDamageWaiverDTO,
  PurchaseDamageWaiverDTOOptional,
  PurchaseDamageWaiverDTOMetaI,
  PurchaseDamageWaiverDTOTrackedI,
} from "./purchase-damage-waiver-dto";
import {
  PurchaseDamageWaiverDTOTracked,
  PurchaseDamageWaiverDTOMeta,
} from "./purchase-damage-waiver-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryDTO,
  PurchaseDeliveryDTOOptional,
  PurchaseDeliveryDTOMetaI,
  PurchaseDeliveryDTOTrackedI,
} from "./purchase-delivery-dto";
import {
  PurchaseDeliveryDTOTracked,
  PurchaseDeliveryDTOMeta,
} from "./purchase-delivery-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDonationDTO,
  PurchaseDonationDTOOptional,
  PurchaseDonationDTOMetaI,
  PurchaseDonationDTOTrackedI,
} from "./purchase-donation-dto";
import {
  PurchaseDonationDTOTracked,
  PurchaseDonationDTOMeta,
} from "./purchase-donation-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseGiftCardDTO,
  PurchaseGiftCardDTOOptional,
  PurchaseGiftCardDTOMetaI,
  PurchaseGiftCardDTOTrackedI,
} from "./purchase-gift-card-dto";
import {
  PurchaseGiftCardDTOTracked,
  PurchaseGiftCardDTOMeta,
} from "./purchase-gift-card-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseGuestPrivilegesDTO,
  PurchaseGuestPrivilegesDTOOptional,
  PurchaseGuestPrivilegesDTOMetaI,
  PurchaseGuestPrivilegesDTOTrackedI,
} from "./purchase-guest-privileges-dto";
import {
  PurchaseGuestPrivilegesDTOTracked,
  PurchaseGuestPrivilegesDTOMeta,
} from "./purchase-guest-privileges-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseMembershipDTO,
  PurchaseMembershipDTOOptional,
  PurchaseMembershipDTOMetaI,
  PurchaseMembershipDTOTrackedI,
} from "./purchase-membership-dto";
import {
  PurchaseMembershipDTOTracked,
  PurchaseMembershipDTOMeta,
} from "./purchase-membership-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseStockedItemDTO,
  PurchaseStockedItemDTOOptional,
  PurchaseStockedItemDTOMetaI,
  PurchaseStockedItemDTOTrackedI,
} from "./purchase-stocked-item-dto";
import {
  PurchaseStockedItemDTOTracked,
  PurchaseStockedItemDTOMeta,
} from "./purchase-stocked-item-dto";

/**
 *
 * @export
 * @interface LineItemDTO
 */
export interface LineItemDTOOptional extends LineItemCalculatedOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDTO
   */
  isNew?: boolean;
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountBaseCents?: number;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountSpecifiedCents?: number;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof LineItemDTO
   */
  amountPaidCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountTotalCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDTO
   */
  autoAdded?: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemDTO
   */
  squareLineItemUid?: string;
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemDTO
   */
  expiresOn?: Date;
  /**
   *
   * @type {number}
   * @memberof LineItemDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemDTO
   */
  referenceId?: string;
  /**
   *
   * @type {LineItemDTORef}
   * @memberof LineItemDTO
   */
  parentItemId?: LineItemDTORefOptional;
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof LineItemDTO
   */
  itemInstanceId?: ItemInstanceRefOptional;
  /**
   *
   * @type {PersonSubscriptionRef}
   * @memberof LineItemDTO
   */
  subscriptionId?: PersonSubscriptionRefOptional;
  /**
   *
   * @type {PurchaseClassSignupDTO}
   * @memberof LineItemDTO
   */
  classSignup?: PurchaseClassSignupDTOOptional;
  /**
   *
   * @type {PurchaseMembershipDTO}
   * @memberof LineItemDTO
   */
  membership?: PurchaseMembershipDTOOptional;
  /**
   *
   * @type {PurchaseDonationDTO}
   * @memberof LineItemDTO
   */
  donation?: PurchaseDonationDTOOptional;
  /**
   *
   * @type {PurchaseCardDTO}
   * @memberof LineItemDTO
   */
  card?: PurchaseCardDTOOptional;
  /**
   *
   * @type {PurchaseGiftCardDTO}
   * @memberof LineItemDTO
   */
  giftCard?: PurchaseGiftCardDTOOptional;
  /**
   *
   * @type {PurchaseGuestPrivilegesDTO}
   * @memberof LineItemDTO
   */
  guestPrivs?: PurchaseGuestPrivilegesDTOOptional;
  /**
   *
   * @type {PurchaseDamageWaiverDTO}
   * @memberof LineItemDTO
   */
  damageWaiver?: PurchaseDamageWaiverDTOOptional;
  /**
   *
   * @type {PurchaseStockedItemDTO}
   * @memberof LineItemDTO
   */
  stockChange?: PurchaseStockedItemDTOOptional;
  /**
   *
   * @type {PurchaseDeliveryDTO}
   * @memberof LineItemDTO
   */
  purchaseDelivery?: PurchaseDeliveryDTOOptional;
  /**
   *
   * @type {Array<LineItemTaxDTO>}
   * @memberof LineItemDTO
   */
  appliedTaxes?: LineItemTaxDTOOptional[];
  /**
   *
   * @type {Array<LineItemDiscountDTO>}
   * @memberof LineItemDTO
   */
  discounts?: LineItemDiscountDTOOptional[];
  /**
   *
   * @type {Array<LineItemRefundDTO>}
   * @memberof LineItemDTO
   */
  refunds?: LineItemRefundDTOOptional[];
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof LineItemDTO
   */
  personInfo?: PersonNameInfoAndRefOptional;
  /**
   * Total value (in cents) of all discounts applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountDiscountsBaseCents?: number;
  /**
   * Total value (in cents) of all discounts applied to all units of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountDiscountsTotalCents?: number;
  /**
   * Total value (in cents) of all taxes applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountTaxesBaseCents?: number;
  /**
   * Total value (in cents) of all taxes applied to all units of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountTaxesTotalCents?: number;
  /**
   * Amount of money to refund (in cents)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountToRefundCents?: number;
  /**
   * Amount of money successfully refunded
   * @type {number}
   * @memberof LineItemDTO
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemDTO
   */
  displayOrder?: number;
}

export interface LineItemDTO
  extends
    LineItemDTOOptional,
    LineItemCalculated,
    LineItemDTORef,
    LineItemFull {
  /**
   *
   * @type {boolean}
   * @memberof LineItemDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDTO
   */
  isNew?: boolean;
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountBaseCents: number;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountSpecifiedCents?: number;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof LineItemDTO
   */
  amountPaidCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountTotalCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDTO
   */
  autoAdded?: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemDTO
   */
  squareLineItemUid?: string;
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemDTO
   */
  expiresOn?: Date;
  /**
   *
   * @type {number}
   * @memberof LineItemDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof LineItemDTO
   */
  referenceId?: string;
  /**
   *
   * @type {LineItemDTORef}
   * @memberof LineItemDTO
   */
  parentItemId?: LineItemDTORef;
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof LineItemDTO
   */
  itemInstanceId: ItemInstanceRef;
  /**
   *
   * @type {PersonSubscriptionRef}
   * @memberof LineItemDTO
   */
  subscriptionId?: PersonSubscriptionRef;
  /**
   *
   * @type {PurchaseClassSignupDTO}
   * @memberof LineItemDTO
   */
  classSignup?: PurchaseClassSignupDTO;
  /**
   *
   * @type {PurchaseMembershipDTO}
   * @memberof LineItemDTO
   */
  membership?: PurchaseMembershipDTO;
  /**
   *
   * @type {PurchaseDonationDTO}
   * @memberof LineItemDTO
   */
  donation?: PurchaseDonationDTO;
  /**
   *
   * @type {PurchaseCardDTO}
   * @memberof LineItemDTO
   */
  card?: PurchaseCardDTO;
  /**
   *
   * @type {PurchaseGiftCardDTO}
   * @memberof LineItemDTO
   */
  giftCard?: PurchaseGiftCardDTO;
  /**
   *
   * @type {PurchaseGuestPrivilegesDTO}
   * @memberof LineItemDTO
   */
  guestPrivs?: PurchaseGuestPrivilegesDTO;
  /**
   *
   * @type {PurchaseDamageWaiverDTO}
   * @memberof LineItemDTO
   */
  damageWaiver?: PurchaseDamageWaiverDTO;
  /**
   *
   * @type {PurchaseStockedItemDTO}
   * @memberof LineItemDTO
   */
  stockChange?: PurchaseStockedItemDTO;
  /**
   *
   * @type {PurchaseDeliveryDTO}
   * @memberof LineItemDTO
   */
  purchaseDelivery?: PurchaseDeliveryDTO;
  /**
   *
   * @type {Array<LineItemTaxDTO>}
   * @memberof LineItemDTO
   */
  appliedTaxes?: LineItemTaxDTO[];
  /**
   *
   * @type {Array<LineItemDiscountDTO>}
   * @memberof LineItemDTO
   */
  discounts?: LineItemDiscountDTO[];
  /**
   *
   * @type {Array<LineItemRefundDTO>}
   * @memberof LineItemDTO
   */
  refunds?: LineItemRefundDTO[];
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof LineItemDTO
   */
  personInfo?: PersonNameInfoAndRef;
  /**
   * Total value (in cents) of all discounts applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountDiscountsBaseCents?: number;
  /**
   * Total value (in cents) of all discounts applied to all units of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountDiscountsTotalCents?: number;
  /**
   * Total value (in cents) of all taxes applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountTaxesBaseCents?: number;
  /**
   * Total value (in cents) of all taxes applied to all units of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountTaxesTotalCents?: number;
  /**
   * Amount of money to refund (in cents)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountToRefundCents?: number;
  /**
   * Amount of money successfully refunded
   * @type {number}
   * @memberof LineItemDTO
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemDTO
   */
  displayOrder?: number;
}

export interface LineItemDTOTrackedI extends LineItemCalculatedOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountBaseCents?: number;
  amountBaseCentsIsSet: boolean;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountSpecifiedCents?: number;
  amountSpecifiedCentsIsSet: boolean;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof LineItemDTO
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountSubtotalCents?: number;
  amountSubtotalCentsIsSet: boolean;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDTO
   */
  autoAdded?: boolean;
  autoAddedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemDTO
   */
  squareLineItemUid?: string;
  squareLineItemUidIsSet: boolean;
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemDTO
   */
  expiresOn?: Date;
  expiresOnIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemDTO
   */
  referenceId?: string;
  referenceIdIsSet: boolean;
  /**
   *
   * @type {LineItemDTORef}
   * @memberof LineItemDTO
   */
  parentItemId?: LineItemDTORefTrackedI;
  parentItemIdIsSet: boolean;
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof LineItemDTO
   */
  itemInstanceId?: ItemInstanceRefTrackedI;
  itemInstanceIdIsSet: boolean;
  /**
   *
   * @type {PersonSubscriptionRef}
   * @memberof LineItemDTO
   */
  subscriptionId?: PersonSubscriptionRefTrackedI;
  subscriptionIdIsSet: boolean;
  /**
   *
   * @type {PurchaseClassSignupDTO}
   * @memberof LineItemDTO
   */
  classSignup?: PurchaseClassSignupDTOTrackedI;
  classSignupIsSet: boolean;
  /**
   *
   * @type {PurchaseMembershipDTO}
   * @memberof LineItemDTO
   */
  membership?: PurchaseMembershipDTOTrackedI;
  membershipIsSet: boolean;
  /**
   *
   * @type {PurchaseDonationDTO}
   * @memberof LineItemDTO
   */
  donation?: PurchaseDonationDTOTrackedI;
  donationIsSet: boolean;
  /**
   *
   * @type {PurchaseCardDTO}
   * @memberof LineItemDTO
   */
  card?: PurchaseCardDTOTrackedI;
  cardIsSet: boolean;
  /**
   *
   * @type {PurchaseGiftCardDTO}
   * @memberof LineItemDTO
   */
  giftCard?: PurchaseGiftCardDTOTrackedI;
  giftCardIsSet: boolean;
  /**
   *
   * @type {PurchaseGuestPrivilegesDTO}
   * @memberof LineItemDTO
   */
  guestPrivs?: PurchaseGuestPrivilegesDTOTrackedI;
  guestPrivsIsSet: boolean;
  /**
   *
   * @type {PurchaseDamageWaiverDTO}
   * @memberof LineItemDTO
   */
  damageWaiver?: PurchaseDamageWaiverDTOTrackedI;
  damageWaiverIsSet: boolean;
  /**
   *
   * @type {PurchaseStockedItemDTO}
   * @memberof LineItemDTO
   */
  stockChange?: PurchaseStockedItemDTOTrackedI;
  stockChangeIsSet: boolean;
  /**
   *
   * @type {PurchaseDeliveryDTO}
   * @memberof LineItemDTO
   */
  purchaseDelivery?: PurchaseDeliveryDTOTrackedI;
  purchaseDeliveryIsSet: boolean;
  /**
   *
   * @type {Array<LineItemTaxDTO>}
   * @memberof LineItemDTO
   */
  appliedTaxes?: LineItemTaxDTOTrackedI[];
  appliedTaxesIsSet: boolean;
  /**
   *
   * @type {Array<LineItemDiscountDTO>}
   * @memberof LineItemDTO
   */
  discounts?: LineItemDiscountDTOTrackedI[];
  discountsIsSet: boolean;
  /**
   *
   * @type {Array<LineItemRefundDTO>}
   * @memberof LineItemDTO
   */
  refunds?: LineItemRefundDTOTrackedI[];
  refundsIsSet: boolean;
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof LineItemDTO
   */
  personInfo?: PersonNameInfoAndRefTrackedI;
  personInfoIsSet: boolean;
  /**
   * Total value (in cents) of all discounts applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountDiscountsBaseCents?: number;
  amountDiscountsBaseCentsIsSet: boolean;
  /**
   * Total value (in cents) of all discounts applied to all units of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountDiscountsTotalCents?: number;
  amountDiscountsTotalCentsIsSet: boolean;
  /**
   * Total value (in cents) of all taxes applied to a single unit of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountTaxesBaseCents?: number;
  amountTaxesBaseCentsIsSet: boolean;
  /**
   * Total value (in cents) of all taxes applied to all units of this line item
   * @type {number}
   * @memberof LineItemDTO
   */
  amountTaxesTotalCents?: number;
  amountTaxesTotalCentsIsSet: boolean;
  /**
   * Amount of money to refund (in cents)
   * @type {number}
   * @memberof LineItemDTO
   */
  amountToRefundCents?: number;
  amountToRefundCentsIsSet: boolean;
  /**
   * Amount of money successfully refunded
   * @type {number}
   * @memberof LineItemDTO
   */
  amountRefundedCents?: number;
  amountRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDTO
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
}

transformDatesMap.set("LineItemDTO", function (model: LineItemDTO) {
  if (typeof model.expiresOn == "string")
    model.expiresOn = new Date(model.expiresOn);
  const transformDatesparentItemId = transformDatesMap.get("LineItemDTORef");
  if (transformDatesparentItemId && model.parentItemId) {
    transformDatesparentItemId(model.parentItemId);
  }
  const transformDatesitemInstanceId = transformDatesMap.get("ItemInstanceRef");
  if (transformDatesitemInstanceId && model.itemInstanceId) {
    transformDatesitemInstanceId(model.itemInstanceId);
  }
  const transformDatessubscriptionId = transformDatesMap.get(
    "PersonSubscriptionRef",
  );
  if (transformDatessubscriptionId && model.subscriptionId) {
    transformDatessubscriptionId(model.subscriptionId);
  }
  const transformDatesclassSignup = transformDatesMap.get(
    "PurchaseClassSignupDTO",
  );
  if (transformDatesclassSignup && model.classSignup) {
    transformDatesclassSignup(model.classSignup);
  }
  const transformDatesmembership = transformDatesMap.get(
    "PurchaseMembershipDTO",
  );
  if (transformDatesmembership && model.membership) {
    transformDatesmembership(model.membership);
  }
  const transformDatesdonation = transformDatesMap.get("PurchaseDonationDTO");
  if (transformDatesdonation && model.donation) {
    transformDatesdonation(model.donation);
  }
  const transformDatescard = transformDatesMap.get("PurchaseCardDTO");
  if (transformDatescard && model.card) {
    transformDatescard(model.card);
  }
  const transformDatesgiftCard = transformDatesMap.get("PurchaseGiftCardDTO");
  if (transformDatesgiftCard && model.giftCard) {
    transformDatesgiftCard(model.giftCard);
  }
  const transformDatesguestPrivs = transformDatesMap.get(
    "PurchaseGuestPrivilegesDTO",
  );
  if (transformDatesguestPrivs && model.guestPrivs) {
    transformDatesguestPrivs(model.guestPrivs);
  }
  const transformDatesdamageWaiver = transformDatesMap.get(
    "PurchaseDamageWaiverDTO",
  );
  if (transformDatesdamageWaiver && model.damageWaiver) {
    transformDatesdamageWaiver(model.damageWaiver);
  }
  const transformDatesstockChange = transformDatesMap.get(
    "PurchaseStockedItemDTO",
  );
  if (transformDatesstockChange && model.stockChange) {
    transformDatesstockChange(model.stockChange);
  }
  const transformDatespurchaseDelivery = transformDatesMap.get(
    "PurchaseDeliveryDTO",
  );
  if (transformDatespurchaseDelivery && model.purchaseDelivery) {
    transformDatespurchaseDelivery(model.purchaseDelivery);
  }
  const transformDatesappliedTaxes = transformDatesMap.get("LineItemTaxDTO");
  if (transformDatesappliedTaxes) {
    model.appliedTaxes?.forEach((sub) => {
      transformDatesappliedTaxes(sub);
    });
  }
  const transformDatesdiscounts = transformDatesMap.get("LineItemDiscountDTO");
  if (transformDatesdiscounts) {
    model.discounts?.forEach((sub) => {
      transformDatesdiscounts(sub);
    });
  }
  const transformDatesrefunds = transformDatesMap.get("LineItemRefundDTO");
  if (transformDatesrefunds) {
    model.refunds?.forEach((sub) => {
      transformDatesrefunds(sub);
    });
  }
  const transformDatespersonInfo = transformDatesMap.get(
    "PersonNameInfoAndRef",
  );
  if (transformDatespersonInfo && model.personInfo) {
    transformDatespersonInfo(model.personInfo);
  }
});

export type LineItemDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  amountBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountSpecifiedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountSubtotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  autoAdded: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  squareLineItemUid: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  expiresOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  referenceId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  parentItemId: PropertyMeta<LineItemDTORefMetaI>;
  //isDate: false
  //isDatetime: false
  itemInstanceId: PropertyMeta<ItemInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  subscriptionId: PropertyMeta<PersonSubscriptionRefMetaI>;
  //isDate: false
  //isDatetime: false
  classSignup: PropertyMeta<PurchaseClassSignupDTOMetaI>;
  //isDate: false
  //isDatetime: false
  membership: PropertyMeta<PurchaseMembershipDTOMetaI>;
  //isDate: false
  //isDatetime: false
  donation: PropertyMeta<PurchaseDonationDTOMetaI>;
  //isDate: false
  //isDatetime: false
  card: PropertyMeta<PurchaseCardDTOMetaI>;
  //isDate: false
  //isDatetime: false
  giftCard: PropertyMeta<PurchaseGiftCardDTOMetaI>;
  //isDate: false
  //isDatetime: false
  guestPrivs: PropertyMeta<PurchaseGuestPrivilegesDTOMetaI>;
  //isDate: false
  //isDatetime: false
  damageWaiver: PropertyMeta<PurchaseDamageWaiverDTOMetaI>;
  //isDate: false
  //isDatetime: false
  stockChange: PropertyMeta<PurchaseStockedItemDTOMetaI>;
  //isDate: false
  //isDatetime: false
  purchaseDelivery: PropertyMeta<PurchaseDeliveryDTOMetaI>;
  //isDate: false
  //isDatetime: false
  appliedTaxes: PropertyMeta<LineItemTaxDTOMetaI>;
  //isDate: false
  //isDatetime: false
  discounts: PropertyMeta<LineItemDiscountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  refunds: PropertyMeta<LineItemRefundDTOMetaI>;
  //isDate: false
  //isDatetime: false
  personInfo: PropertyMeta<PersonNameInfoAndRefMetaI>;
  //isDate: false
  //isDatetime: false
  amountDiscountsBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountDiscountsTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTaxesBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTaxesTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
}>;

export var LineItemDTOMeta: LineItemDTOMetaI = {} as LineItemDTOMetaI;
LineItemDTOMeta = typeMeta("LineItemDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  amountBaseCents: propertyMeta(
    "amountBaseCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  amountSpecifiedCents: propertyMeta(
    "amountSpecifiedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountSubtotalCents: propertyMeta(
    "amountSubtotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  autoAdded: propertyMeta(
    "autoAdded",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  squareLineItemUid: propertyMeta(
    "squareLineItemUid",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  expiresOn: propertyMeta("expiresOn", false, false, false, MetaTypesBase.Date),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  referenceId: propertyMeta(
    "referenceId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  parentItemId: propertyMeta(
    "parentItemId",
    false,
    false,
    false,
    LineItemDTORefMeta,
  ),
  itemInstanceId: propertyMeta(
    "itemInstanceId",
    false,
    true,
    false,
    ItemInstanceRefMeta,
  ),
  subscriptionId: propertyMeta(
    "subscriptionId",
    false,
    false,
    false,
    PersonSubscriptionRefMeta,
  ),
  classSignup: propertyMeta(
    "classSignup",
    false,
    false,
    false,
    PurchaseClassSignupDTOMeta,
  ),
  membership: propertyMeta(
    "membership",
    false,
    false,
    false,
    PurchaseMembershipDTOMeta,
  ),
  donation: propertyMeta(
    "donation",
    false,
    false,
    false,
    PurchaseDonationDTOMeta,
  ),
  card: propertyMeta("card", false, false, false, PurchaseCardDTOMeta),
  giftCard: propertyMeta(
    "giftCard",
    false,
    false,
    false,
    PurchaseGiftCardDTOMeta,
  ),
  guestPrivs: propertyMeta(
    "guestPrivs",
    false,
    false,
    false,
    PurchaseGuestPrivilegesDTOMeta,
  ),
  damageWaiver: propertyMeta(
    "damageWaiver",
    false,
    false,
    false,
    PurchaseDamageWaiverDTOMeta,
  ),
  stockChange: propertyMeta(
    "stockChange",
    false,
    false,
    false,
    PurchaseStockedItemDTOMeta,
  ),
  purchaseDelivery: propertyMeta(
    "purchaseDelivery",
    false,
    false,
    false,
    PurchaseDeliveryDTOMeta,
  ),
  appliedTaxes: propertyMeta(
    "appliedTaxes",
    true,
    false,
    false,
    LineItemTaxDTOMeta,
  ),
  discounts: propertyMeta(
    "discounts",
    true,
    false,
    false,
    LineItemDiscountDTOMeta,
  ),
  refunds: propertyMeta("refunds", true, false, false, LineItemRefundDTOMeta),
  personInfo: propertyMeta(
    "personInfo",
    false,
    false,
    false,
    PersonNameInfoAndRefMeta,
  ),
  amountDiscountsBaseCents: propertyMeta(
    "amountDiscountsBaseCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountDiscountsTotalCents: propertyMeta(
    "amountDiscountsTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTaxesBaseCents: propertyMeta(
    "amountTaxesBaseCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTaxesTotalCents: propertyMeta(
    "amountTaxesTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToRefundCents: propertyMeta(
    "amountToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountRefundedCents: propertyMeta(
    "amountRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = LineItemDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([LineItemFullMeta]);
  metaI.isDeleted.inheritedFrom = LineItemFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = LineItemFullMeta.isNew;
  metaI.amountBaseCents.inheritedFrom = LineItemFullMeta.amountBaseCents;
  metaI.amountSpecifiedCents.inheritedFrom =
    LineItemFullMeta.amountSpecifiedCents;
  metaI.amountPaidCents.inheritedFrom = LineItemFullMeta.amountPaidCents;
  metaI.amountSubtotalCents.inheritedFrom =
    LineItemFullMeta.amountSubtotalCents;
  metaI.amountTotalCents.inheritedFrom = LineItemFullMeta.amountTotalCents;
  metaI.autoAdded.inheritedFrom = LineItemFullMeta.autoAdded;
  metaI.squareLineItemUid.inheritedFrom = LineItemFullMeta.squareLineItemUid;
  metaI.expiresOn.inheritedFrom = LineItemFullMeta.expiresOn;
  metaI.assignId.inheritedFrom = LineItemFullMeta.assignId;
  metaI.referenceId.inheritedFrom = LineItemFullMeta.referenceId;
  metaI.parentItemId.inheritedFrom = LineItemFullMeta.parentItemId;
  metaI.itemInstanceId.inheritedFrom = LineItemFullMeta.itemInstanceId;
  metaI.subscriptionId.inheritedFrom = LineItemFullMeta.subscriptionId;
  metaI.classSignup.inheritedFrom = LineItemFullMeta.classSignup;
  metaI.membership.inheritedFrom = LineItemFullMeta.membership;
  metaI.donation.inheritedFrom = LineItemFullMeta.donation;
  metaI.card.inheritedFrom = LineItemFullMeta.card;
  metaI.giftCard.inheritedFrom = LineItemFullMeta.giftCard;
  metaI.guestPrivs.inheritedFrom = LineItemFullMeta.guestPrivs;
  metaI.damageWaiver.inheritedFrom = LineItemFullMeta.damageWaiver;
  metaI.stockChange.inheritedFrom = LineItemFullMeta.stockChange;
  metaI.purchaseDelivery.inheritedFrom = LineItemFullMeta.purchaseDelivery;
  metaI.appliedTaxes.inheritedFrom = LineItemFullMeta.appliedTaxes;
  metaI.discounts.inheritedFrom = LineItemFullMeta.discounts;
  metaI.refunds.inheritedFrom = LineItemFullMeta.refunds;
  metaI.interfaces = metaI.interfaces.concat([LineItemDTORefMeta]);
  metaI.assignId.inheritedFrom = LineItemDTORefMeta.assignId;
  metaI.referenceId.inheritedFrom = LineItemDTORefMeta.referenceId;
  metaI.interfaces = metaI.interfaces.concat([LineItemCalculatedMeta]);
  metaI.personInfo.inheritedFrom = LineItemCalculatedMeta.personInfo;
  metaI.amountDiscountsBaseCents.inheritedFrom =
    LineItemCalculatedMeta.amountDiscountsBaseCents;
  metaI.amountDiscountsTotalCents.inheritedFrom =
    LineItemCalculatedMeta.amountDiscountsTotalCents;
  metaI.amountTaxesBaseCents.inheritedFrom =
    LineItemCalculatedMeta.amountTaxesBaseCents;
  metaI.amountTaxesTotalCents.inheritedFrom =
    LineItemCalculatedMeta.amountTaxesTotalCents;
  metaI.amountToRefundCents.inheritedFrom =
    LineItemCalculatedMeta.amountToRefundCents;
  metaI.amountRefundedCents.inheritedFrom =
    LineItemCalculatedMeta.amountRefundedCents;
  metaI.displayOrder.inheritedFrom = LineItemCalculatedMeta.displayOrder;
});

export class LineItemDTOTracked
  extends LineItemCalculatedTracked
  implements LineItemDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  amountBaseCents__I?: number = undefined;
  amountBaseCentsIsSet: boolean = false;
  set amountBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountBaseCents__I = v;
      this.amountBaseCentsIsSet = true;
    } else {
      this.amountBaseCents__I = v || undefined;
      this.amountBaseCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get amountBaseCents() {
    return this.amountBaseCents__I;
  }
  amountSpecifiedCents__I?: number = undefined;
  amountSpecifiedCentsIsSet: boolean = false;
  set amountSpecifiedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSpecifiedCents__I = v;
      this.amountSpecifiedCentsIsSet = true;
    } else {
      this.amountSpecifiedCents__I = v || undefined;
      this.amountSpecifiedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSpecifiedCents() {
    return this.amountSpecifiedCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  amountSubtotalCents__I?: number = undefined;
  amountSubtotalCentsIsSet: boolean = false;
  set amountSubtotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSubtotalCents__I = v;
      this.amountSubtotalCentsIsSet = true;
    } else {
      this.amountSubtotalCents__I = v || undefined;
      this.amountSubtotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSubtotalCents() {
    return this.amountSubtotalCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  autoAdded__I?: boolean = undefined;
  autoAddedIsSet: boolean = false;
  set autoAdded(v: undefined | boolean) {
    if (v !== undefined) {
      this.autoAdded__I = v;
      this.autoAddedIsSet = true;
    } else {
      this.autoAdded__I = v || undefined;
      this.autoAddedIsSet = false;
    }
    this.changeTracker = true;
  }
  get autoAdded() {
    return this.autoAdded__I;
  }
  squareLineItemUid__I?: string = undefined;
  squareLineItemUidIsSet: boolean = false;
  set squareLineItemUid(v: undefined | string) {
    if (v !== undefined) {
      this.squareLineItemUid__I = v;
      this.squareLineItemUidIsSet = true;
    } else {
      this.squareLineItemUid__I = v || undefined;
      this.squareLineItemUidIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareLineItemUid() {
    return this.squareLineItemUid__I;
  }
  expiresOn__I?: Date = undefined;
  expiresOnIsSet: boolean = false;
  set expiresOn(v: undefined | Date) {
    if (v !== undefined) {
      this.expiresOn__I = v;
      this.expiresOnIsSet = true;
    } else {
      this.expiresOn__I = v || undefined;
      this.expiresOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get expiresOn() {
    return this.expiresOn__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  referenceId__I?: string = undefined;
  referenceIdIsSet: boolean = false;
  set referenceId(v: undefined | string) {
    if (v !== undefined) {
      this.referenceId__I = v;
      this.referenceIdIsSet = true;
    } else {
      this.referenceId__I = v || undefined;
      this.referenceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get referenceId() {
    return this.referenceId__I;
  }
  parentItemId__I?: LineItemDTORefTracked = undefined;
  parentItemIdIsSet: boolean = false;
  set parentItemId(v: undefined | LineItemDTORefTracked) {
    if (v !== undefined) {
      this.parentItemId__I = v;
      this.parentItemIdIsSet = true;
    } else {
      this.parentItemId__I = v || undefined;
      this.parentItemIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get parentItemId() {
    return this.parentItemId__I;
  }
  itemInstanceId__I?: ItemInstanceRefTracked = undefined;
  itemInstanceIdIsSet: boolean = false;
  set itemInstanceId(v: undefined | ItemInstanceRefTracked) {
    if (v !== undefined) {
      this.itemInstanceId__I = v;
      this.itemInstanceIdIsSet = true;
    } else {
      this.itemInstanceId__I = v || undefined;
      this.itemInstanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get itemInstanceId() {
    return this.itemInstanceId__I;
  }
  subscriptionId__I?: PersonSubscriptionRefTracked = undefined;
  subscriptionIdIsSet: boolean = false;
  set subscriptionId(v: undefined | PersonSubscriptionRefTracked) {
    if (v !== undefined) {
      this.subscriptionId__I = v;
      this.subscriptionIdIsSet = true;
    } else {
      this.subscriptionId__I = v || undefined;
      this.subscriptionIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get subscriptionId() {
    return this.subscriptionId__I;
  }
  classSignup__I?: PurchaseClassSignupDTOTracked = undefined;
  classSignupIsSet: boolean = false;
  set classSignup(v: undefined | PurchaseClassSignupDTOTracked) {
    if (v !== undefined) {
      this.classSignup__I = v;
      this.classSignupIsSet = true;
    } else {
      this.classSignup__I = v || undefined;
      this.classSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get classSignup() {
    return this.classSignup__I;
  }
  membership__I?: PurchaseMembershipDTOTracked = undefined;
  membershipIsSet: boolean = false;
  set membership(v: undefined | PurchaseMembershipDTOTracked) {
    if (v !== undefined) {
      this.membership__I = v;
      this.membershipIsSet = true;
    } else {
      this.membership__I = v || undefined;
      this.membershipIsSet = false;
    }
    this.changeTracker = true;
  }
  get membership() {
    return this.membership__I;
  }
  donation__I?: PurchaseDonationDTOTracked = undefined;
  donationIsSet: boolean = false;
  set donation(v: undefined | PurchaseDonationDTOTracked) {
    if (v !== undefined) {
      this.donation__I = v;
      this.donationIsSet = true;
    } else {
      this.donation__I = v || undefined;
      this.donationIsSet = false;
    }
    this.changeTracker = true;
  }
  get donation() {
    return this.donation__I;
  }
  card__I?: PurchaseCardDTOTracked = undefined;
  cardIsSet: boolean = false;
  set card(v: undefined | PurchaseCardDTOTracked) {
    if (v !== undefined) {
      this.card__I = v;
      this.cardIsSet = true;
    } else {
      this.card__I = v || undefined;
      this.cardIsSet = false;
    }
    this.changeTracker = true;
  }
  get card() {
    return this.card__I;
  }
  giftCard__I?: PurchaseGiftCardDTOTracked = undefined;
  giftCardIsSet: boolean = false;
  set giftCard(v: undefined | PurchaseGiftCardDTOTracked) {
    if (v !== undefined) {
      this.giftCard__I = v;
      this.giftCardIsSet = true;
    } else {
      this.giftCard__I = v || undefined;
      this.giftCardIsSet = false;
    }
    this.changeTracker = true;
  }
  get giftCard() {
    return this.giftCard__I;
  }
  guestPrivs__I?: PurchaseGuestPrivilegesDTOTracked = undefined;
  guestPrivsIsSet: boolean = false;
  set guestPrivs(v: undefined | PurchaseGuestPrivilegesDTOTracked) {
    if (v !== undefined) {
      this.guestPrivs__I = v;
      this.guestPrivsIsSet = true;
    } else {
      this.guestPrivs__I = v || undefined;
      this.guestPrivsIsSet = false;
    }
    this.changeTracker = true;
  }
  get guestPrivs() {
    return this.guestPrivs__I;
  }
  damageWaiver__I?: PurchaseDamageWaiverDTOTracked = undefined;
  damageWaiverIsSet: boolean = false;
  set damageWaiver(v: undefined | PurchaseDamageWaiverDTOTracked) {
    if (v !== undefined) {
      this.damageWaiver__I = v;
      this.damageWaiverIsSet = true;
    } else {
      this.damageWaiver__I = v || undefined;
      this.damageWaiverIsSet = false;
    }
    this.changeTracker = true;
  }
  get damageWaiver() {
    return this.damageWaiver__I;
  }
  stockChange__I?: PurchaseStockedItemDTOTracked = undefined;
  stockChangeIsSet: boolean = false;
  set stockChange(v: undefined | PurchaseStockedItemDTOTracked) {
    if (v !== undefined) {
      this.stockChange__I = v;
      this.stockChangeIsSet = true;
    } else {
      this.stockChange__I = v || undefined;
      this.stockChangeIsSet = false;
    }
    this.changeTracker = true;
  }
  get stockChange() {
    return this.stockChange__I;
  }
  purchaseDelivery__I?: PurchaseDeliveryDTOTracked = undefined;
  purchaseDeliveryIsSet: boolean = false;
  set purchaseDelivery(v: undefined | PurchaseDeliveryDTOTracked) {
    if (v !== undefined) {
      this.purchaseDelivery__I = v;
      this.purchaseDeliveryIsSet = true;
    } else {
      this.purchaseDelivery__I = v || undefined;
      this.purchaseDeliveryIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDelivery() {
    return this.purchaseDelivery__I;
  }
  appliedTaxes__I?: LineItemTaxDTOTracked[] = undefined;
  appliedTaxesIsSet: boolean = false;
  set appliedTaxes(v: undefined | LineItemTaxDTOTracked[]) {
    if (v !== undefined) {
      this.appliedTaxes__I = v;
      this.appliedTaxesIsSet = true;
    } else {
      this.appliedTaxes__I = v || undefined;
      this.appliedTaxesIsSet = false;
    }
    this.changeTracker = true;
  }
  get appliedTaxes() {
    return this.appliedTaxes__I;
  }
  discounts__I?: LineItemDiscountDTOTracked[] = undefined;
  discountsIsSet: boolean = false;
  set discounts(v: undefined | LineItemDiscountDTOTracked[]) {
    if (v !== undefined) {
      this.discounts__I = v;
      this.discountsIsSet = true;
    } else {
      this.discounts__I = v || undefined;
      this.discountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get discounts() {
    return this.discounts__I;
  }
  refunds__I?: LineItemRefundDTOTracked[] = undefined;
  refundsIsSet: boolean = false;
  set refunds(v: undefined | LineItemRefundDTOTracked[]) {
    if (v !== undefined) {
      this.refunds__I = v;
      this.refundsIsSet = true;
    } else {
      this.refunds__I = v || undefined;
      this.refundsIsSet = false;
    }
    this.changeTracker = true;
  }
  get refunds() {
    return this.refunds__I;
  }
  personInfo__I?: PersonNameInfoAndRefTracked = undefined;
  personInfoIsSet: boolean = false;
  set personInfo(v: undefined | PersonNameInfoAndRefTracked) {
    if (v !== undefined) {
      this.personInfo__I = v;
      this.personInfoIsSet = true;
    } else {
      this.personInfo__I = v || undefined;
      this.personInfoIsSet = false;
    }
    this.changeTracker = true;
  }
  get personInfo() {
    return this.personInfo__I;
  }
  amountDiscountsBaseCents__I?: number = undefined;
  amountDiscountsBaseCentsIsSet: boolean = false;
  set amountDiscountsBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountDiscountsBaseCents__I = v;
      this.amountDiscountsBaseCentsIsSet = true;
    } else {
      this.amountDiscountsBaseCents__I = v || undefined;
      this.amountDiscountsBaseCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountDiscountsBaseCents() {
    return this.amountDiscountsBaseCents__I;
  }
  amountDiscountsTotalCents__I?: number = undefined;
  amountDiscountsTotalCentsIsSet: boolean = false;
  set amountDiscountsTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountDiscountsTotalCents__I = v;
      this.amountDiscountsTotalCentsIsSet = true;
    } else {
      this.amountDiscountsTotalCents__I = v || undefined;
      this.amountDiscountsTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountDiscountsTotalCents() {
    return this.amountDiscountsTotalCents__I;
  }
  amountTaxesBaseCents__I?: number = undefined;
  amountTaxesBaseCentsIsSet: boolean = false;
  set amountTaxesBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTaxesBaseCents__I = v;
      this.amountTaxesBaseCentsIsSet = true;
    } else {
      this.amountTaxesBaseCents__I = v || undefined;
      this.amountTaxesBaseCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTaxesBaseCents() {
    return this.amountTaxesBaseCents__I;
  }
  amountTaxesTotalCents__I?: number = undefined;
  amountTaxesTotalCentsIsSet: boolean = false;
  set amountTaxesTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTaxesTotalCents__I = v;
      this.amountTaxesTotalCentsIsSet = true;
    } else {
      this.amountTaxesTotalCents__I = v || undefined;
      this.amountTaxesTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTaxesTotalCents() {
    return this.amountTaxesTotalCents__I;
  }
  amountToRefundCents__I?: number = undefined;
  amountToRefundCentsIsSet: boolean = false;
  set amountToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundCents__I = v;
      this.amountToRefundCentsIsSet = true;
    } else {
      this.amountToRefundCents__I = v || undefined;
      this.amountToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundCents() {
    return this.amountToRefundCents__I;
  }
  amountRefundedCents__I?: number = undefined;
  amountRefundedCentsIsSet: boolean = false;
  set amountRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountRefundedCents__I = v;
      this.amountRefundedCentsIsSet = true;
    } else {
      this.amountRefundedCents__I = v || undefined;
      this.amountRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountRefundedCents() {
    return this.amountRefundedCents__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  constructor(config?: LineItemDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.referenceIdIsSet == true && other?.referenceIdIsSet == true)
      return this.referenceId == other.referenceId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.parentItemId?.setIds();

    this.itemInstanceId?.setIds();

    this.subscriptionId?.setIds();

    this.classSignup?.setIds();

    this.membership?.setIds();

    this.donation?.setIds();

    this.card?.setIds();

    this.giftCard?.setIds();

    this.guestPrivs?.setIds();

    this.damageWaiver?.setIds();

    this.stockChange?.setIds();

    this.purchaseDelivery?.setIds();

    this.appliedTaxes?.forEach((a) => a.setIds());

    this.discounts?.forEach((a) => a.setIds());

    this.refunds?.forEach((a) => a.setIds());
    this.personInfo?.setIds();
  }
  assignFrom(
    config: LineItemDTOOptional,
    options?: AssignOptions,
  ): LineItemDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.amountBaseCents &&
      this.amountBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountBaseCents = config.amountBaseCents;
      if (optionsRequired.unassign) this.amountBaseCentsIsSet = false;
      else this.amountBaseCentsIsSet = true;
    }
    if (
      config.amountSpecifiedCents &&
      this.amountSpecifiedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSpecifiedCents = config.amountSpecifiedCents;
      if (optionsRequired.unassign) this.amountSpecifiedCentsIsSet = false;
      else this.amountSpecifiedCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (
      config.amountSubtotalCents &&
      this.amountSubtotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSubtotalCents = config.amountSubtotalCents;
      if (optionsRequired.unassign) this.amountSubtotalCentsIsSet = false;
      else this.amountSubtotalCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (config.autoAdded && this.autoAddedApplyFilter(optionsRequired.filter)) {
      this.autoAdded = config.autoAdded;
      if (optionsRequired.unassign) this.autoAddedIsSet = false;
      else this.autoAddedIsSet = true;
    }
    if (
      config.squareLineItemUid &&
      this.squareLineItemUidApplyFilter(optionsRequired.filter)
    ) {
      this.squareLineItemUid = config.squareLineItemUid;
      if (optionsRequired.unassign) this.squareLineItemUidIsSet = false;
      else this.squareLineItemUidIsSet = true;
    }
    if (config.expiresOn && this.expiresOnApplyFilter(optionsRequired.filter)) {
      this.expiresOn = config.expiresOn;
      if (optionsRequired.unassign) this.expiresOnIsSet = false;
      else this.expiresOnIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.referenceId &&
      this.referenceIdApplyFilter(optionsRequired.filter)
    ) {
      this.referenceId = config.referenceId;
      if (optionsRequired.unassign) this.referenceIdIsSet = false;
      else this.referenceIdIsSet = true;
    }
    if (
      config.parentItemId &&
      this.parentItemIdApplyFilter(optionsRequired.filter)
    ) {
      this.parentItemId = new LineItemDTORefTracked(
        config.parentItemId,
        options,
      );
      if (optionsRequired.unassign) this.parentItemIdIsSet = false;
      else this.parentItemIdIsSet = true;
    }
    if (
      config.itemInstanceId &&
      this.itemInstanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.itemInstanceId = new ItemInstanceRefTracked(
        config.itemInstanceId,
        options,
      );
      if (optionsRequired.unassign) this.itemInstanceIdIsSet = false;
      else this.itemInstanceIdIsSet = true;
    }
    if (
      config.subscriptionId &&
      this.subscriptionIdApplyFilter(optionsRequired.filter)
    ) {
      this.subscriptionId = new PersonSubscriptionRefTracked(
        config.subscriptionId,
        options,
      );
      if (optionsRequired.unassign) this.subscriptionIdIsSet = false;
      else this.subscriptionIdIsSet = true;
    }
    if (
      config.classSignup &&
      this.classSignupApplyFilter(optionsRequired.filter)
    ) {
      this.classSignup = new PurchaseClassSignupDTOTracked(
        config.classSignup,
        options,
      );
      if (optionsRequired.unassign) this.classSignupIsSet = false;
      else this.classSignupIsSet = true;
    }
    if (
      config.membership &&
      this.membershipApplyFilter(optionsRequired.filter)
    ) {
      this.membership = new PurchaseMembershipDTOTracked(
        config.membership,
        options,
      );
      if (optionsRequired.unassign) this.membershipIsSet = false;
      else this.membershipIsSet = true;
    }
    if (config.donation && this.donationApplyFilter(optionsRequired.filter)) {
      this.donation = new PurchaseDonationDTOTracked(config.donation, options);
      if (optionsRequired.unassign) this.donationIsSet = false;
      else this.donationIsSet = true;
    }
    if (config.card && this.cardApplyFilter(optionsRequired.filter)) {
      this.card = new PurchaseCardDTOTracked(config.card, options);
      if (optionsRequired.unassign) this.cardIsSet = false;
      else this.cardIsSet = true;
    }
    if (config.giftCard && this.giftCardApplyFilter(optionsRequired.filter)) {
      this.giftCard = new PurchaseGiftCardDTOTracked(config.giftCard, options);
      if (optionsRequired.unassign) this.giftCardIsSet = false;
      else this.giftCardIsSet = true;
    }
    if (
      config.guestPrivs &&
      this.guestPrivsApplyFilter(optionsRequired.filter)
    ) {
      this.guestPrivs = new PurchaseGuestPrivilegesDTOTracked(
        config.guestPrivs,
        options,
      );
      if (optionsRequired.unassign) this.guestPrivsIsSet = false;
      else this.guestPrivsIsSet = true;
    }
    if (
      config.damageWaiver &&
      this.damageWaiverApplyFilter(optionsRequired.filter)
    ) {
      this.damageWaiver = new PurchaseDamageWaiverDTOTracked(
        config.damageWaiver,
        options,
      );
      if (optionsRequired.unassign) this.damageWaiverIsSet = false;
      else this.damageWaiverIsSet = true;
    }
    if (
      config.stockChange &&
      this.stockChangeApplyFilter(optionsRequired.filter)
    ) {
      this.stockChange = new PurchaseStockedItemDTOTracked(
        config.stockChange,
        options,
      );
      if (optionsRequired.unassign) this.stockChangeIsSet = false;
      else this.stockChangeIsSet = true;
    }
    if (
      config.purchaseDelivery &&
      this.purchaseDeliveryApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDelivery = new PurchaseDeliveryDTOTracked(
        config.purchaseDelivery,
        options,
      );
      if (optionsRequired.unassign) this.purchaseDeliveryIsSet = false;
      else this.purchaseDeliveryIsSet = true;
    }
    if (
      config.appliedTaxes &&
      this.appliedTaxesApplyFilter(optionsRequired.filter)
    ) {
      this.appliedTaxes = config.appliedTaxes?.map(
        (a) => new LineItemTaxDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.appliedTaxesIsSet = false;
      else this.appliedTaxesIsSet = true;
    }
    if (config.discounts && this.discountsApplyFilter(optionsRequired.filter)) {
      this.discounts = config.discounts?.map(
        (a) => new LineItemDiscountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.discountsIsSet = false;
      else this.discountsIsSet = true;
    }
    if (config.refunds && this.refundsApplyFilter(optionsRequired.filter)) {
      this.refunds = config.refunds?.map(
        (a) => new LineItemRefundDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.refundsIsSet = false;
      else this.refundsIsSet = true;
    }
    if (
      config.personInfo &&
      this.personInfoApplyFilter(optionsRequired.filter)
    ) {
      this.personInfo = new PersonNameInfoAndRefTracked(
        config.personInfo,
        options,
      );
      if (optionsRequired.unassign) this.personInfoIsSet = false;
      else this.personInfoIsSet = true;
    }
    if (
      config.amountDiscountsBaseCents &&
      this.amountDiscountsBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountDiscountsBaseCents = config.amountDiscountsBaseCents;
      if (optionsRequired.unassign) this.amountDiscountsBaseCentsIsSet = false;
      else this.amountDiscountsBaseCentsIsSet = true;
    }
    if (
      config.amountDiscountsTotalCents &&
      this.amountDiscountsTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountDiscountsTotalCents = config.amountDiscountsTotalCents;
      if (optionsRequired.unassign) this.amountDiscountsTotalCentsIsSet = false;
      else this.amountDiscountsTotalCentsIsSet = true;
    }
    if (
      config.amountTaxesBaseCents &&
      this.amountTaxesBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTaxesBaseCents = config.amountTaxesBaseCents;
      if (optionsRequired.unassign) this.amountTaxesBaseCentsIsSet = false;
      else this.amountTaxesBaseCentsIsSet = true;
    }
    if (
      config.amountTaxesTotalCents &&
      this.amountTaxesTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTaxesTotalCents = config.amountTaxesTotalCents;
      if (optionsRequired.unassign) this.amountTaxesTotalCentsIsSet = false;
      else this.amountTaxesTotalCentsIsSet = true;
    }
    if (
      config.amountToRefundCents &&
      this.amountToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundCents = config.amountToRefundCents;
      if (optionsRequired.unassign) this.amountToRefundCentsIsSet = false;
      else this.amountToRefundCentsIsSet = true;
    }
    if (
      config.amountRefundedCents &&
      this.amountRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountRefundedCents = config.amountRefundedCents;
      if (optionsRequired.unassign) this.amountRefundedCentsIsSet = false;
      else this.amountRefundedCentsIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemDTOTrackedI {
    const cloned = {} as LineItemDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.amountBaseCentsIsSetDeep() &&
      this.amountBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountBaseCentsIsSet = true;
      cloned.amountBaseCents = this.amountBaseCents;
    } else {
      //cloned.amountBaseCentsIsSet = false
    }
    if (
      this.amountSpecifiedCentsIsSetDeep() &&
      this.amountSpecifiedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSpecifiedCentsIsSet = true;
      cloned.amountSpecifiedCents = this.amountSpecifiedCents;
    } else {
      //cloned.amountSpecifiedCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.amountSubtotalCentsIsSetDeep() &&
      this.amountSubtotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSubtotalCentsIsSet = true;
      cloned.amountSubtotalCents = this.amountSubtotalCents;
    } else {
      //cloned.amountSubtotalCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.autoAddedIsSetDeep() &&
      this.autoAddedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.autoAddedIsSet = true;
      cloned.autoAdded = this.autoAdded;
    } else {
      //cloned.autoAddedIsSet = false
    }
    if (
      this.squareLineItemUidIsSetDeep() &&
      this.squareLineItemUidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareLineItemUidIsSet = true;
      cloned.squareLineItemUid = this.squareLineItemUid;
    } else {
      //cloned.squareLineItemUidIsSet = false
    }
    if (
      this.expiresOnIsSetDeep() &&
      this.expiresOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expiresOnIsSet = true;
      cloned.expiresOn = this.expiresOn;
    } else {
      //cloned.expiresOnIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.referenceIdIsSetDeep() &&
      this.referenceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referenceIdIsSet = true;
      cloned.referenceId = this.referenceId;
    } else {
      //cloned.referenceIdIsSet = false
    }
    if (
      this.parentItemIdIsSetDeep() &&
      this.parentItemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.parentItemIdIsSet = true;
      cloned.parentItemId = this.parentItemId?.removeUnset(filter);
    } else {
      //cloned.parentItemIdIsSet = false
    }
    if (
      this.itemInstanceIdIsSetDeep() &&
      this.itemInstanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemInstanceIdIsSet = true;
      cloned.itemInstanceId = this.itemInstanceId?.removeUnset(filter);
    } else {
      //cloned.itemInstanceIdIsSet = false
    }
    if (
      this.subscriptionIdIsSetDeep() &&
      this.subscriptionIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.subscriptionIdIsSet = true;
      cloned.subscriptionId = this.subscriptionId?.removeUnset(filter);
    } else {
      //cloned.subscriptionIdIsSet = false
    }
    if (
      this.classSignupIsSetDeep() &&
      this.classSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classSignupIsSet = true;
      cloned.classSignup = this.classSignup?.removeUnset(filter);
    } else {
      //cloned.classSignupIsSet = false
    }
    if (
      this.membershipIsSetDeep() &&
      this.membershipApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.membershipIsSet = true;
      cloned.membership = this.membership?.removeUnset(filter);
    } else {
      //cloned.membershipIsSet = false
    }
    if (
      this.donationIsSetDeep() &&
      this.donationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.donationIsSet = true;
      cloned.donation = this.donation?.removeUnset(filter);
    } else {
      //cloned.donationIsSet = false
    }
    if (
      this.cardIsSetDeep() &&
      this.cardApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cardIsSet = true;
      cloned.card = this.card?.removeUnset(filter);
    } else {
      //cloned.cardIsSet = false
    }
    if (
      this.giftCardIsSetDeep() &&
      this.giftCardApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.giftCardIsSet = true;
      cloned.giftCard = this.giftCard?.removeUnset(filter);
    } else {
      //cloned.giftCardIsSet = false
    }
    if (
      this.guestPrivsIsSetDeep() &&
      this.guestPrivsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.guestPrivsIsSet = true;
      cloned.guestPrivs = this.guestPrivs?.removeUnset(filter);
    } else {
      //cloned.guestPrivsIsSet = false
    }
    if (
      this.damageWaiverIsSetDeep() &&
      this.damageWaiverApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.damageWaiverIsSet = true;
      cloned.damageWaiver = this.damageWaiver?.removeUnset(filter);
    } else {
      //cloned.damageWaiverIsSet = false
    }
    if (
      this.stockChangeIsSetDeep() &&
      this.stockChangeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stockChangeIsSet = true;
      cloned.stockChange = this.stockChange?.removeUnset(filter);
    } else {
      //cloned.stockChangeIsSet = false
    }
    if (
      this.purchaseDeliveryIsSetDeep() &&
      this.purchaseDeliveryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDeliveryIsSet = true;
      cloned.purchaseDelivery = this.purchaseDelivery?.removeUnset(filter);
    } else {
      //cloned.purchaseDeliveryIsSet = false
    }
    if (
      this.appliedTaxesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.appliedTaxesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.appliedTaxesIsSet = true;
      cloned.appliedTaxes = this.appliedTaxes
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.appliedTaxesIsSet = false
    }
    if (
      this.discountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.discountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountsIsSet = true;
      cloned.discounts = this.discounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.discountsIsSet = false
    }
    if (
      this.refundsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.refundsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.refundsIsSet = true;
      cloned.refunds = this.refunds
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.refundsIsSet = false
    }
    if (
      this.personInfoIsSetDeep() &&
      this.personInfoApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personInfoIsSet = true;
      cloned.personInfo = this.personInfo?.removeUnset(filter);
    } else {
      //cloned.personInfoIsSet = false
    }
    if (
      this.amountDiscountsBaseCentsIsSetDeep() &&
      this.amountDiscountsBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountDiscountsBaseCentsIsSet = true;
      cloned.amountDiscountsBaseCents = this.amountDiscountsBaseCents;
    } else {
      //cloned.amountDiscountsBaseCentsIsSet = false
    }
    if (
      this.amountDiscountsTotalCentsIsSetDeep() &&
      this.amountDiscountsTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountDiscountsTotalCentsIsSet = true;
      cloned.amountDiscountsTotalCents = this.amountDiscountsTotalCents;
    } else {
      //cloned.amountDiscountsTotalCentsIsSet = false
    }
    if (
      this.amountTaxesBaseCentsIsSetDeep() &&
      this.amountTaxesBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTaxesBaseCentsIsSet = true;
      cloned.amountTaxesBaseCents = this.amountTaxesBaseCents;
    } else {
      //cloned.amountTaxesBaseCentsIsSet = false
    }
    if (
      this.amountTaxesTotalCentsIsSetDeep() &&
      this.amountTaxesTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTaxesTotalCentsIsSet = true;
      cloned.amountTaxesTotalCents = this.amountTaxesTotalCents;
    } else {
      //cloned.amountTaxesTotalCentsIsSet = false
    }
    if (
      this.amountToRefundCentsIsSetDeep() &&
      this.amountToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundCentsIsSet = true;
      cloned.amountToRefundCents = this.amountToRefundCents;
    } else {
      //cloned.amountToRefundCentsIsSet = false
    }
    if (
      this.amountRefundedCentsIsSetDeep() &&
      this.amountRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountRefundedCentsIsSet = true;
      cloned.amountRefundedCents = this.amountRefundedCents;
    } else {
      //cloned.amountRefundedCentsIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.amountBaseCentsApplyFilter(filter))
      this.amountBaseCentsIsSet = false;

    if (!this.amountSpecifiedCentsApplyFilter(filter))
      this.amountSpecifiedCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.amountSubtotalCentsApplyFilter(filter))
      this.amountSubtotalCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.autoAddedApplyFilter(filter)) this.autoAddedIsSet = false;

    if (!this.squareLineItemUidApplyFilter(filter))
      this.squareLineItemUidIsSet = false;

    if (!this.expiresOnApplyFilter(filter)) this.expiresOnIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.referenceIdApplyFilter(filter)) this.referenceIdIsSet = false;

    if (!this.parentItemIdApplyFilter(filter)) this.parentItemIdIsSet = false;
    this.parentItemId?.unassignAll(filter);

    if (!this.itemInstanceIdApplyFilter(filter))
      this.itemInstanceIdIsSet = false;
    this.itemInstanceId?.unassignAll(filter);

    if (!this.subscriptionIdApplyFilter(filter))
      this.subscriptionIdIsSet = false;
    this.subscriptionId?.unassignAll(filter);

    if (!this.classSignupApplyFilter(filter)) this.classSignupIsSet = false;
    this.classSignup?.unassignAll(filter);

    if (!this.membershipApplyFilter(filter)) this.membershipIsSet = false;
    this.membership?.unassignAll(filter);

    if (!this.donationApplyFilter(filter)) this.donationIsSet = false;
    this.donation?.unassignAll(filter);

    if (!this.cardApplyFilter(filter)) this.cardIsSet = false;
    this.card?.unassignAll(filter);

    if (!this.giftCardApplyFilter(filter)) this.giftCardIsSet = false;
    this.giftCard?.unassignAll(filter);

    if (!this.guestPrivsApplyFilter(filter)) this.guestPrivsIsSet = false;
    this.guestPrivs?.unassignAll(filter);

    if (!this.damageWaiverApplyFilter(filter)) this.damageWaiverIsSet = false;
    this.damageWaiver?.unassignAll(filter);

    if (!this.stockChangeApplyFilter(filter)) this.stockChangeIsSet = false;
    this.stockChange?.unassignAll(filter);

    if (!this.purchaseDeliveryApplyFilter(filter))
      this.purchaseDeliveryIsSet = false;
    this.purchaseDelivery?.unassignAll(filter);

    if (!this.appliedTaxesApplyFilter(filter)) this.appliedTaxesIsSet = false;

    this.appliedTaxes?.forEach((a) => a.unassignAll(filter));
    if (!this.discountsApplyFilter(filter)) this.discountsIsSet = false;

    this.discounts?.forEach((a) => a.unassignAll(filter));
    if (!this.refundsApplyFilter(filter)) this.refundsIsSet = false;

    this.refunds?.forEach((a) => a.unassignAll(filter));
    if (!this.personInfoApplyFilter(filter)) this.personInfoIsSet = false;
    this.personInfo?.unassignAll(filter);

    if (!this.amountDiscountsBaseCentsApplyFilter(filter))
      this.amountDiscountsBaseCentsIsSet = false;

    if (!this.amountDiscountsTotalCentsApplyFilter(filter))
      this.amountDiscountsTotalCentsIsSet = false;

    if (!this.amountTaxesBaseCentsApplyFilter(filter))
      this.amountTaxesBaseCentsIsSet = false;

    if (!this.amountTaxesTotalCentsApplyFilter(filter))
      this.amountTaxesTotalCentsIsSet = false;

    if (!this.amountToRefundCentsApplyFilter(filter))
      this.amountToRefundCentsIsSet = false;

    if (!this.amountRefundedCentsApplyFilter(filter))
      this.amountRefundedCentsIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.isDeleted,
      LineItemDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(LineItemDTOMeta.isNew, LineItemDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  amountBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountBaseCents,
      LineItemDTOMeta,
      this.amountBaseCents,
      this,
    );
  }
  amountBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountBaseCentsIsSet && this.amountBaseCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountSpecifiedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountSpecifiedCents,
      LineItemDTOMeta,
      this.amountSpecifiedCents,
      this,
    );
  }
  amountSpecifiedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSpecifiedCentsIsSet &&
      this.amountSpecifiedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountPaidCents,
      LineItemDTOMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountSubtotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountSubtotalCents,
      LineItemDTOMeta,
      this.amountSubtotalCents,
      this,
    );
  }
  amountSubtotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSubtotalCentsIsSet &&
      this.amountSubtotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountTotalCents,
      LineItemDTOMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  autoAddedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.autoAdded,
      LineItemDTOMeta,
      this.autoAdded,
      this,
    );
  }
  autoAddedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.autoAddedIsSet && this.autoAddedApplyFilter(filter)) return true;

    return false;
  }
  squareLineItemUidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.squareLineItemUid,
      LineItemDTOMeta,
      this.squareLineItemUid,
      this,
    );
  }
  squareLineItemUidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.squareLineItemUidIsSet &&
      this.squareLineItemUidApplyFilter(filter)
    )
      return true;

    return false;
  }
  expiresOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.expiresOn,
      LineItemDTOMeta,
      this.expiresOn,
      this,
    );
  }
  expiresOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expiresOnIsSet && this.expiresOnApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.assignId,
      LineItemDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  referenceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.referenceId,
      LineItemDTOMeta,
      this.referenceId,
      this,
    );
  }
  referenceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referenceIdIsSet && this.referenceIdApplyFilter(filter))
      return true;

    return false;
  }
  parentItemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.parentItemId,
      LineItemDTOMeta,
      this.parentItemId,
      this,
    );
  }
  parentItemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.parentItemIdIsSet && this.parentItemIdApplyFilter(filter))
      return true;
    return this.parentItemId?.anySet(filter) == true;

    return false;
  }
  itemInstanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.itemInstanceId,
      LineItemDTOMeta,
      this.itemInstanceId,
      this,
    );
  }
  itemInstanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemInstanceIdIsSet && this.itemInstanceIdApplyFilter(filter))
      return true;
    return this.itemInstanceId?.anySet(filter) == true;

    return false;
  }
  subscriptionIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.subscriptionId,
      LineItemDTOMeta,
      this.subscriptionId,
      this,
    );
  }
  subscriptionIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.subscriptionIdIsSet && this.subscriptionIdApplyFilter(filter))
      return true;
    return this.subscriptionId?.anySet(filter) == true;

    return false;
  }
  classSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.classSignup,
      LineItemDTOMeta,
      this.classSignup,
      this,
    );
  }
  classSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classSignupIsSet && this.classSignupApplyFilter(filter))
      return true;
    return this.classSignup?.anySet(filter) == true;

    return false;
  }
  membershipApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.membership,
      LineItemDTOMeta,
      this.membership,
      this,
    );
  }
  membershipIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.membershipIsSet && this.membershipApplyFilter(filter)) return true;
    return this.membership?.anySet(filter) == true;

    return false;
  }
  donationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.donation,
      LineItemDTOMeta,
      this.donation,
      this,
    );
  }
  donationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.donationIsSet && this.donationApplyFilter(filter)) return true;
    return this.donation?.anySet(filter) == true;

    return false;
  }
  cardApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(LineItemDTOMeta.card, LineItemDTOMeta, this.card, this);
  }
  cardIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cardIsSet && this.cardApplyFilter(filter)) return true;
    return this.card?.anySet(filter) == true;

    return false;
  }
  giftCardApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.giftCard,
      LineItemDTOMeta,
      this.giftCard,
      this,
    );
  }
  giftCardIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.giftCardIsSet && this.giftCardApplyFilter(filter)) return true;
    return this.giftCard?.anySet(filter) == true;

    return false;
  }
  guestPrivsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.guestPrivs,
      LineItemDTOMeta,
      this.guestPrivs,
      this,
    );
  }
  guestPrivsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.guestPrivsIsSet && this.guestPrivsApplyFilter(filter)) return true;
    return this.guestPrivs?.anySet(filter) == true;

    return false;
  }
  damageWaiverApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.damageWaiver,
      LineItemDTOMeta,
      this.damageWaiver,
      this,
    );
  }
  damageWaiverIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.damageWaiverIsSet && this.damageWaiverApplyFilter(filter))
      return true;
    return this.damageWaiver?.anySet(filter) == true;

    return false;
  }
  stockChangeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.stockChange,
      LineItemDTOMeta,
      this.stockChange,
      this,
    );
  }
  stockChangeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.stockChangeIsSet && this.stockChangeApplyFilter(filter))
      return true;
    return this.stockChange?.anySet(filter) == true;

    return false;
  }
  purchaseDeliveryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.purchaseDelivery,
      LineItemDTOMeta,
      this.purchaseDelivery,
      this,
    );
  }
  purchaseDeliveryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDeliveryIsSet && this.purchaseDeliveryApplyFilter(filter))
      return true;
    return this.purchaseDelivery?.anySet(filter) == true;

    return false;
  }
  appliedTaxesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.appliedTaxes,
      LineItemDTOMeta,
      this.appliedTaxes,
      this,
    );
  }
  appliedTaxesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.appliedTaxesIsSet && this.appliedTaxesApplyFilter(filter))
      return true;

    return this.appliedTaxes?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  discountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.discounts,
      LineItemDTOMeta,
      this.discounts,
      this,
    );
  }
  discountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountsIsSet && this.discountsApplyFilter(filter)) return true;

    return this.discounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  refundsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(LineItemDTOMeta.refunds, LineItemDTOMeta, this.refunds, this);
  }
  refundsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.refundsIsSet && this.refundsApplyFilter(filter)) return true;

    return this.refunds?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  personInfoApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.personInfo,
      LineItemDTOMeta,
      this.personInfo,
      this,
    );
  }
  personInfoIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personInfoIsSet && this.personInfoApplyFilter(filter)) return true;
    return this.personInfo?.anySet(filter) == true;

    return false;
  }
  amountDiscountsBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountDiscountsBaseCents,
      LineItemDTOMeta,
      this.amountDiscountsBaseCents,
      this,
    );
  }
  amountDiscountsBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountDiscountsBaseCentsIsSet &&
      this.amountDiscountsBaseCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountDiscountsTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountDiscountsTotalCents,
      LineItemDTOMeta,
      this.amountDiscountsTotalCents,
      this,
    );
  }
  amountDiscountsTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountDiscountsTotalCentsIsSet &&
      this.amountDiscountsTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTaxesBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountTaxesBaseCents,
      LineItemDTOMeta,
      this.amountTaxesBaseCents,
      this,
    );
  }
  amountTaxesBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountTaxesBaseCentsIsSet &&
      this.amountTaxesBaseCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTaxesTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountTaxesTotalCents,
      LineItemDTOMeta,
      this.amountTaxesTotalCents,
      this,
    );
  }
  amountTaxesTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountTaxesTotalCentsIsSet &&
      this.amountTaxesTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountToRefundCents,
      LineItemDTOMeta,
      this.amountToRefundCents,
      this,
    );
  }
  amountToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundCentsIsSet &&
      this.amountToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.amountRefundedCents,
      LineItemDTOMeta,
      this.amountRefundedCents,
      this,
    );
  }
  amountRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountRefundedCentsIsSet &&
      this.amountRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDTOMeta.displayOrder,
      LineItemDTOMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.amountBaseCentsIsSetDeep(filter)) return true;
    if (this.amountSpecifiedCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.amountSubtotalCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.autoAddedIsSetDeep(filter)) return true;
    if (this.squareLineItemUidIsSetDeep(filter)) return true;
    if (this.expiresOnIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.referenceIdIsSetDeep(filter)) return true;
    if (this.parentItemIdIsSetDeep(filter)) return true;
    if (this.itemInstanceIdIsSetDeep(filter)) return true;
    if (this.subscriptionIdIsSetDeep(filter)) return true;
    if (this.classSignupIsSetDeep(filter)) return true;
    if (this.membershipIsSetDeep(filter)) return true;
    if (this.donationIsSetDeep(filter)) return true;
    if (this.cardIsSetDeep(filter)) return true;
    if (this.giftCardIsSetDeep(filter)) return true;
    if (this.guestPrivsIsSetDeep(filter)) return true;
    if (this.damageWaiverIsSetDeep(filter)) return true;
    if (this.stockChangeIsSetDeep(filter)) return true;
    if (this.purchaseDeliveryIsSetDeep(filter)) return true;
    if (this.appliedTaxesIsSetDeep(filter)) return true;
    if (this.discountsIsSetDeep(filter)) return true;
    if (this.refundsIsSetDeep(filter)) return true;
    if (this.personInfoIsSetDeep(filter)) return true;
    if (this.amountDiscountsBaseCentsIsSetDeep(filter)) return true;
    if (this.amountDiscountsTotalCentsIsSetDeep(filter)) return true;
    if (this.amountTaxesBaseCentsIsSetDeep(filter)) return true;
    if (this.amountTaxesTotalCentsIsSetDeep(filter)) return true;
    if (this.amountToRefundCentsIsSetDeep(filter)) return true;
    if (this.amountRefundedCentsIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
